import React from 'react';

const DeleteModal = ({ translate, deleteAccount } : { translate: any, deleteAccount: Function }) => (
  <div className="modal fade" id="delete-acount-modal" tabIndex="-1" role="dialog" aria-hidden="true">
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-message">
          <h3>{translate('settings.sure')}</h3>
          <h4>{translate('settings.recently_create')}</h4>
          <p>{translate('settings.calls')}<br /><em>{translate('settings.no_obligations')}</em></p>
          <ul className="btns">
            <li>
              <a data-dismiss="modal" className="btn btn-success btn-lg">{translate('settings.keep_it')}</a>
            </li>
            <li>
              <a
                data-dismiss="modal"
                onClick={deleteAccount}
                className="js-delete-button btn btn-danger btn-lg delete-confirm">
                {translate('settings.yes_delete')}
              </a>
            </li>
          </ul>
        </div>
        <button type="button" className="btn-close" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
);

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/main/settings/deleteModal.js